import { render } from "./StoreInfoPage.vue?vue&type=template&id=48d91040"
import script from "./StoreInfoPage.vue?vue&type=script&lang=js"
export * from "./StoreInfoPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__